import { useParams } from 'react-router-dom'
import EditLessonForm from './EditLessonForm'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import { useGetLessonsQuery } from './lessonsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditLesson = () => {
    useTitle('geshtop-Exercise: Edit Lesson')

    const { lessonId } = useParams()

    const { lesson } = useGetLessonsQuery("lessonsList", {
        selectFromResult: ({ data }) => ({
            lesson: data?.entities[lessonId]
        }),
    })

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!lesson || !groups) return <PulseLoader color={"#FFF"} />

    const content = <EditLessonForm lesson={lesson} groups={groups} />

    return content
}
export default EditLesson